import { lazy, ComponentType } from "react";

export function lazyWithRetry<T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>
) {
  return lazy(() =>
    factory().catch((err) => {
      const isFramed = (() => {
        try {
          return typeof window !== "undefined" && window.self !== window.top;
        } catch {
          return true;
        }
      })();

      if (isFramed) {
        throw err;
      }

      // If chunk fails to load, try a hard reload once
      const key = "chunk-reload-" + factory.toString().slice(0, 50);
      const hasReloaded = sessionStorage.getItem(key);
      if (!hasReloaded) {
        sessionStorage.setItem(key, "true");
        window.location.reload();
        // Return a never-resolving promise to prevent rendering during reload
        return new Promise<{ default: T }>(() => {});
      }
      throw err;
    })
  );
}
